import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from "./Form.js";
import ContentWithImages from "./ContentWithImages.js";
import DoctorBite from "../../DoctorBite.js";
import PatientReviews from "../../PatientReview.js";

import GetInTouch from "../../GetInTouch.js";
import FollowYt from "../../FollowYt.js";
import Counter from "../../../NumCounter.js";
import Breadcrumb from "../../Breadcrum.js";

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
      <Helmet>
      <title>Speech Therapy in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
      <meta name="description" content="Get professional speech therapy in Delhi, India. Improve speech, communication, and voice disorders with expert therapists at MedFirst ENT Centre." />
      <meta name="keywords" content="speech therapy Delhi, speech specialist, communication disorder therapy, Speech therapy cost,Speech therapy techniques,Speech therapy for kids,Speech therapy near me,Speech therapy for adults,Speech Therapist Near Me with fees,Speech Therapy cost in Delhi" />
      <link rel="canonical" href="https://entdelhi.com/speech-therapy/" />
            <meta property="og:title" content="Speech Therapy in Delhi, India | Treatment, Cost, Doctor, Clinic" />
      <meta property="og:description" content="Get professional speech therapy in Delhi, India. Improve speech, communication, and voice disorders with expert therapists at MedFirst ENT Centre." />
      <meta name="robots" content="index, follow" />
      {/* You can add more meta tags as needed */}
    </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
        <ContentWithImages />
        <FollowYt />
        <DoctorBite />
        <PatientReviews />
        
        <GetInTouch />
      </main>
    </div>
  );
}
